import { useMutation } from '@tanstack/react-query';
import { checkCryptoAddress } from '../requests';
import type { CryptoAddressCheckResponse } from '../../model';

type Params = {
  network: string;
  address: string;
};

export const useCheckCryptoAddressMutation = () => {
  const mutation = useMutation<CryptoAddressCheckResponse, Error, Params>({
    mutationFn: ({ network, address }) => {
      return checkCryptoAddress(network, address);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
  };
};
